{
  "form": {
    "fields": {
      "name": "Nombre",
      "confirm_name": "Confirmar Nombre",
      "confirm_email": "Confirmar Email",
      "username": "Nombre de usuario",
      "email": "Email",
      "password": "Contraseña",
      "host": "Anfitrión",
      "format": "Formato",
      "beta": "Beta",
      "enabled": "Habilitado",
      "port": "Puerto",
      "description": "Descripción",
      "id": "ID",
      "uuid": "UUID",
      "identifier": "Identificador",
      "author": "Autor",
      "ip": "IP",
      "alias": "Alias",
      "ports": "Puertos",
      "phpmyadmin_url": "URL de phpMyAdmin",
      "name_first": "Primer nombre",
      "name_last": "Apellido",
      "preferences": {
        "language": "Idioma",
        "navbar_position": "Posición del Navbar"
      },
      "new_email": "Nueva dirección de Email",
      "current_password": "Contraseña Actual",
      "new_password": "Nueva Contraseña",
      "new_password_confirmation": "Repetir Nueva Contraseña",
      "root_admin": "Administrador",
      "support_op": "Soporte OP",
      "support_op_bypass": "Bypasear Soporte OP",
      "external_id": "ID Externo",
      "token": "Token",
      "memo": "Nota",
      "allowed_ips": "IPs de conexión permitidos",
      "connection_address": "Dirección de conexión",
      "connections_from": "Conexiones desde",
      "folder_name": "Nombre de la carpeta",
      "file_name": "Nombre del archivo",
      "edition": "Edición",
      "version": "Versión",
      "repository": "URL del repositorio",
      "branch": "Rama",
      "access_token": "Token de Acceso Personal",
      "workshop_url": "URL de taller",
      "show_non_high_severity": "Mostrar resultados sin filtrar",
      "time_offset": "Desfase de tiempo",
      "cron_minute": "Minuto",
      "cron_hour": "Hora",
      "cron_day_of_week": "Día de la Semana",
      "cron_day_of_month": "Día del Mes",
      "action": "Acción",
      "payload": "Carga",
      "panel_url": "URL del Panel",
      "application_api_key": "Clave API de la aplicación",
      "users": "Usuarios",
      "content": "Contenido",
      "type": "Tipo",
      "fqdn": "FQDN",
      "display_fqdn": "Mostrar FQDN",
      "maintenance_mode": "Modo Mantenimiento",
      "location": "Ubicación",
      "egg": "Huevo",
      "nest": "Nido",
      "docker_image": "Imagen de Docker",
      "startup": "Comando de Inicio",
      "cpu": "CPU",
      "memory": "Memoria",
      "swap": "SWAP",
      "disk": "Disco",
      "block_io_proportion": "Proporción de Bloque IO",
      "overallocate": "Sobreasignación",
      "database_limit": "Límite de base de datos",
      "allocation_limit": "Límite de adjudicación",
      "backup_megabytes_limit": "Límite de tamaño de copia de seguridad",
      "category": "Categoría",
      "script_install": "Script de Instalación",
      "script_uninstall": "Script de Desinstalación",
      "config_from": "Copiar ajustes desde",
      "config_logs": "Configuración de Log",
      "config_startup": "Configuración de Inicio",
      "custom_config": "Configuración Personalizada",
      "config_files": "Archivos de configuración",
      "stop_command": "Comando de Detener",
      "copy_script_from": "Copiar Script desde",
      "script_container": "Contenedor de script",
      "script_entry": "Entrada del script",
      "env_variable": "Variable de Entorno",
      "default_value": "Valor por Defecto",
      "tickable": "Elegible",
      "user_viewable": "Visible por el Usuario",
      "user_editable": "Editable por el Usuario",
      "rules": "Reglas",
      "allocation": "Asignación",
      "primary_allocation": "Asignación primaria",
      "secondary_allocations": "Asignación secundaria",
      "add_allocations": "Añadir Asignaciones Adicionales",
      "remove_allocations": "Eliminar asignaciones adicionales",
      "server_owner": "Propietario del Servidor",
      "startup_command": "Comando de Inicio",
      "default_startup_command": "Comando de Inicio por Defecto",
      "node": "Nodo",
      "backup": "Respaldar",
      "force": "Forzar",
      "start_on_completion": "Iniciar el servidor cuando esté instalado",
      "skip_scripts": "Saltarse script de instalación",
      "oom_disabled": "Desactivar el asesino OOM",
      "domain_name": "Nombre de Dominio",
      "nest_identifiers": "Identificadores de nidos",
      "egg_identifiers": "Identificadores de huevos",
      "root_record": "Registro de la raíz",
      "branding": {
        "name": "Nombre de la empresa"
      },
      "misc": {
        "databases_allow_random": "Habilitar despliegue de base de datos en nodos aleatorios",
        "required_2fa": "Requiere autenticación de 2-Factor"
      },
      "default_locale": "Idioma por Defecto",
      "og": {
        "site_name": "Nombre del Sitio",
        "title": "Título",
        "description": "Descripción",
        "image": "URL de la imagen"
      },
      "whmcs": {
        "enabled": "WHMCS SSO habilitado",
        "button_text": "Texto del botón de inicio de sesión",
        "url": "URL de WHMCS",
        "client_id": "ID de cliente WHMCS",
        "client_secret": "Secreto del cliente WHMCS",
        "api_id": "ID API WHMCS",
        "api_secret": "Secreto WHMCS API"
      },
      "variable_value": "{env} variable"
    },
    "validation_error": "Hay el siguiente error: | Hay los siguientes errores:",
    "validator": {
      "accepted": "El valor debe ser aceptado | El campo {attribute} debe ser aceptado",
      "active_url": "El valor no es una URL válida | El campo {attribute} no es una URL válida",
      "after": "El valor debe ser una fecha posterior a {date} | El campo {attribute} debe ser una fecha posterior a {date}",
      "after_or_equal": "El valor debe ser una fecha posterior o igual a {date} | El campo {attribute} debe ser una fecha posterior o igual a {date}",
      "alpha": "El valor sólo puede contener letras | El campo {attribute} sólo puede contener letras",
      "alpha_dash": "El valor solo puede contener letras, números y guiones | El campo {attribute} solo puede contener letras, números y guiones",
      "alpha_num": "El valor solo puede contener letras y números | El campo {attribute} sólo puede contener letras y números",
      "array": "El valor debe ser un array | El campo {attribute} debe ser un array",
      "before": "El valor debe ser una fecha anterior a {date} | El campo {attribute} debe ser una fecha anterior a {date}",
      "before_or_equal": "El valor debe ser una fecha anterior o igual a {date} | El campo {attribute} debe ser una fecha anterior o igual a {date}",
      "between": {
        "numeric": "El valor debe estar entre {min} y {max} | El campo {attribute} debe estar entre {min} y {max}",
        "file": "El valor debe estar entre {min} y {max} kilobytes | El campo {attribute} debe estar entre {min} y {max} kilobytes",
        "string": "El valor debe tener entre {min} y {max} caracteres | El campo {attribute} debe tener entre {min} y {max} caracteres",
        "array": "El valor debe estar entre {min} y {max} elementos | El campo {attribute} debe estar entre {min} y {max} elementos"
      },
      "boolean": "El valor debe ser verdadero o falso | El campo {attribute} debe ser verdadero o falso",
      "confirmed": "La confirmación de valor no coincide | La confirmación del campo {attribute} no coincide",
      "date": "El valor no es una fecha válida | El campo {attribute} no es una fecha válida",
      "date_format": "El valor no coincide con el formato {format} | El campo {attribute} no coincide con el formato {format}",
      "different": "El valor y {other} deben ser diferentes | El campo {attribute} y {other} deben ser diferentes",
      "digits": "El valor debe tener {digits} dígitos | El campo {attribute} debe tener {digits} dígitos",
      "digits_between": "El valor debe estar entre {min} y {max} dígitos | El campo {attribute} debe tener entre {min} y {max} dígitos",
      "dimensions": "El valor tiene dimensiones de imagen no válidas | El campo {attribute} tiene dimensiones de imagen no válidas",
      "distinct": "El valor tiene un valor duplicado | El campo {attribute} tiene un valor duplicado",
      "email": "Correo electrónico no válido | Email no válido para el campo {field}",
      "exists": "El valor no es válido | El campo {attribute} no es válido",
      "file": "El valor debe ser un archivo | El campo {attribute} debe ser un archivo",
      "filled": "El valor es obligatorio | El campo {attribute} es obligatorio",
      "image": "El valor debe ser una imagen | El campo {attribute} debe ser una imagen",
      "in": "El valor no es válido | El campo {attribute} no es válido",
      "in_array": "El valor no existe en {other} | El campo {attribute} no existe en {other}",
      "integer": "El valor debe ser un entero válido | El campo {attribute} debe ser un entero.",
      "ip": "El valor debe ser una dirección IP válida | El campo {attribute} debe ser una dirección IP válida",
      "json": "El valor debe ser una cadena JSON válida | El campo {attribute} debe ser una cadena JSON válida",
      "max": {
        "numeric": "El valor no puede ser mayor que {max} | El campo {attribute} no debe ser mayor que {max}",
        "file": "El valor no puede ser mayor que {max} kilobytes | El campo {attribute} no debe ser mayor que {max} kilobytes",
        "string": "El valor no debe ser mayor que {max} caracteres | El campo {attribute} no debe ser mayor que {max} caracteres",
        "array": "El valor no puede ser mayor que {max} elementos | El campo {attribute} no puede ser mayor que {max} elementos"
      },
      "mimes": "El valor debe ser un archivo de tipo: {values} | El campo {attribute} debe ser un archivo de tipo: {values}",
      "mimetypes": "El valor debe ser un archivo de tipo: {values} | El campo {attribute} debe ser un archivo de tipo: {values}",
      "min": {
        "numeric": "El valor debe ser al menos {min} | El campo {attribute} debe ser al menos {min}",
        "file": "El valor debe ser de al menos {min} kilobytes | El campo {attribute} debe ser de al menos {min} kilobytes",
        "string": "El valor debe tener al menos {min} caracteres | El campo {attribute} debe tener al menos {min} caracteres",
        "array": "El valor debe ser al menos {min} artículos | El campo {attribute} debe ser al menos {min} artículos"
      },
      "not_in": "El valor no es válido | El campo {attribute} no es válido",
      "numeric": "El valor debe ser un número | El campo {attribute} debe ser un número",
      "present": "El valor debe estar presente | El campo {attribute} debe estar presente",
      "regex": "El valor no es válido | El campo {attribute} no es válido",
      "required": "El campo es obligatorio | El campo {attribute} es obligatorio",
      "required_if": "El valor es requerido cuando {other} es {value} | El campo {attribute} es obligatorio cuando {other} es {value}",
      "required_unless": "El valor es requerido a menos que {other} esté en {values} | El campo {attribute} es obligatorio a menos que {other} esté en {values}",
      "required_with": "El valor es obligatorio cuando {values} está presente | El campo {attribute} es obligatorio cuando {values} está presente",
      "required_with_all": "El valor es obligatorio cuando {values} está presente | El campo {attribute} es obligatorio cuando {values} está presente",
      "required_without": "El valor es obligatorio cuando {values} no está presente | El campo {attribute} es obligatorio cuando {values} no está presente",
      "required_without_all": "El valor es obligatorio cuando ninguno de {values} está presente | El campo {attribute} es obligatorio cuando ninguno de {values} está presente",
      "same": "El valor y {other} deben coincidir | El campo {attribute} y {other} deben coincidir",
      "size": {
        "numeric": "El valor debe ser {size} | El campo {attribute} debe ser {size}",
        "file": "El valor debe ser {size} kilobytes | El campo {attribute} debe ser {size} kilobytes",
        "string": "El valor debe tener {size} caracteres | El campo {attribute} debe tener {size} caracteres",
        "array": "El valor debe ser {size} artículos | El campo {attribute} debe ser {size} artículos"
      },
      "string": "El valor debe ser una cadena | El campo {attribute} debe ser una cadena",
      "timezone": "El valor debe ser una zona válida | El campo {attribute} debe ser una zona válida",
      "unique": "El valor ya está ocupado | El campo {attribute} ya está ocupado",
      "uploaded": "El valor no se ha podido cargar | El campo {attribute} no ha podido subir",
      "url": "El valor no es válido | El campo {attribute} no es válido"
    }
  },
  "table": {
    "labels": {
      "key": "Clave",
      "memo": "Nota",
      "last_used": "Último uso",
      "created": "Creado",
      "uuid": "UUID",
      "id": "ID",
      "email": "Email",
      "name": "Nombre",
      "description": "Descripción",
      "owner": "Propietario",
      "connection": "Conexión",
      "username": "Nombre de usuario",
      "password": "Contraseña",
      "2fa": "2FA",
      "downloads": "Descargas",
      "queued": "En cola",
      "tasks": "Tareas",
      "last_run": "Última ejecución",
      "next_run": "Siguiente ejecución",
      "file_name": "Nombre del archivo",
      "size": "Tamaño",
      "created_at": "Creado el",
      "migrated_at": "Migrado el",
      "last_modified": "Última Modificación",
      "allocation": "Asignación",
      "fqdn": "FQDN",
      "ip": "IP",
      "alias": "Alias",
      "port": "Puerto",
      "plan": "Plan",
      "domain": "Dominio",
      "licensed_to": "Licenciado a",
      "expires": "Expira",
      "addons": "Complementos",
      "version": "Versión",
      "category": "Categoría",
      "active": "Activa",
      "content": "Contenido",
      "host": "Anfitrión",
      "databases": "Bases de datos",
      "node": "Nodo",
      "server": "Servidor",
      "connections_from": "Conexiones desde",
      "nodes": "Nodos",
      "servers": "Servidores",
      "eggs": "Huevos",
      "location": "Ubicación",
      "cpu": "CPU",
      "memory": "Memoria",
      "disk": "Disco",
      "assigned_to": "Asignado a",
      "internal_identifier": "Identificador interno",
      "external_identifier": "Identificador Externo",
      "service": "Servicio",
      "block_io_weight": "Peso del Bloque IO",
      "backup_size_limit": "Límite de tamaño de copia de seguridad",
      "default_connection": "Conexión por Defecto",
      "connection_alias": "Alias de Conexión",
      "domain_name": "Nombre de Dominio"
    }
  }
}
